import { render, staticRenderFns } from "./OssIndexAnalyzer.vue?vue&type=template&id=65eb7f9a&"
import script from "./OssIndexAnalyzer.vue?vue&type=script&lang=js&"
export * from "./OssIndexAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports